import React from 'react';
import Seo from './common/Seo';

import Drawer from "./common/Drawer";
import PageTitle from "./common/PageTitle";
import { useI18n } from "./i18n/I18nContext";

function NotFound({route}) {
  const { t } = useI18n();
  const title = t("pages.notFound.title");
  const description = t("pages.notFound.description");

  return [
    <Seo title={title} description={description} noindex />,
    <PageTitle id="not-found" title={t("pages.notFound.heading")} text={t("pages.notFound.text")} />,
    <Drawer route={route} />
  ];
}

export default NotFound;
